import { Dispatch } from 'redux'

import { SelectOptionLocal } from '../../../types/common/commonTypes'
import { apiInstance } from '../../api/apiInstance'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const getAllOilsAPI =
    (searchTerm: string, typeId?: string) =>
    async (dispatch: Dispatch): Promise<void> => {
        dispatch({ type: storeDispatchTypes.setPartsLoader, value: { field: 'oilsAPI', value: true } })

        try {
            const {
                data: { status, data },
            } = await apiInstance.post('/dicts/avito/OilsAPI', { typeId })
            const oilsAPI: SelectOptionLocal[] = []

            if (status === 'ok') {
                const parser = new DOMParser()
                const xmlDoc = parser.parseFromString(data, 'text/xml')
                const APIsNodes = xmlDoc.getElementsByTagName('API')

                for (let i = 0; i < APIsNodes.length; i++) {
                    const APIName = APIsNodes[i].textContent?.trim()
                    if (APIName && APIName.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())) {
                        oilsAPI.push({ name: APIName, value: APIName })
                    }
                }
            }
            dispatch({ type: storeDispatchTypes.setAllOilsAPI, value: { oilsAPI } })
        } catch (e) {
            console.error('load oilsAPI failed', e)
        }

        dispatch({ type: storeDispatchTypes.setPartsLoader, value: { field: 'oilsAPI', value: false } })
    }

export default getAllOilsAPI
